export default __webpack_public_path__ + "static/dbf7f71d-2979-40c1-beda-f7b889ae9d0e-0856e036dfa036a2d5f4ad6d172d8bd6.woff";